import i18nMain from "./vi/i18nMain";
import i18nValidate from "./vi/i18nValidate";
import i18nCommon from "./vi/i18nCommon";
import i18nEnum from "./vi/i18nEnum";
import i18nComponent from "./vi/i18nComponent";
import i18nLayoutColumn from "./vi/i18nLayoutColumn";
import i18nBaseForm from "./vi/i18nBaseForm";
import i18nAsset from "./vi/i18nAsset";
import i18nAssetType from "./vi/i18nAssetType";
import i18nProvider from "./vi/i18nProvider";
import i18nOrganizationUnit from "./vi/i18nOrganizationUnit";
import i18nLocation from "./vi/i18nLocation";
import i18nPickList from "./vi/i18nPickList";
import i18nJobPosition from "./vi/i18nJobPosition";
import i18nJobTitle from "./vi/i18nJobTitle";
import i18nJobPositionAsset from "./vi/i18nJobPositionAsset";
import i18nRole from "./vi/i18nRole";
import i18nEmployee from "./vi/i18nEmployee";
import i18nReport from "./vi/i18nReport";
import i18nUser from "./vi/i18nUser";
import i18nCustomer from "./vi/i18nCustomer";
import i18nDBOption from "./vi/i18nDBOption";
import i18nAuditingLog from "./vi/i18nAuditingLog";
import i18nAudit from "./vi/i18nAudit";
import i18nLogin from "./vi/i18nLogin";
import i18nTally from "./vi/i18nTally";
import i18nAssetCategory from "./vi/i18nAssetCategory";
import i18nAllocationReduce from "./vi/i18nAllocationReduce";
import i18nMultiReduce from "./vi/i18nMultiReduce";
import i18nMultiAllocation from "./vi/i18nMultiAllocation";
import i18nMaintainRepair from "./vi/i18nMaintainRepair";
import i18nGetting from "./vi/i18nGetting";
import i18nIdentify from "./vi/i18nIdentify";
import i18nImport from "./vi/i18nImport";
import i18nMaintenance from "./vi/i18nMaintenance";
import i18nColumn from "./vi/i18nColumn";
import i18nSchedule from "./vi/i18nSchedule";
import i18nAssetReduce from "./vi/i18nAssetReduceDetail";
import i18nLostCancelLiquidated from "./vi/i18nLostCancelLiquidated";
import i18nTransfer from "./vi/i18nTransfer";
import i18nTemplate from "./vi/i18nTemplate";
import i18nTourGuide from "./vi/i18nTourGuide";
import i18nSY from "./vi/i18nSY";
import i18nTransferAdd from "./vi/i18nTransferAdd";
import i18nAssetRepairMaintenance from "./vi/i18nAssetRepairMaintenance";
import i18nDisposal from "./vi/i18nDisposal";
import i18nAssetLostCancelLiquidated from "./vi/i18nAssetLostCancelLiquidated";
import i18nDashboard from "./vi/i18nDashboard";
import i18nMultiDisposal from "./vi/i18nMultiDisposal";
import i18nPages from "./vi/i18nPages";
import i18nPrintBarCode from "./vi/i18nPrintBarCode";
import i18nOption from "./vi/i18nOption";
import i18nTransactionControl from "./vi/i18nTransactionControl";
import i18nTransaction from "./vi/i18nTransaction";
import i18nRefund from "./vi/i18nRefund";
import i18nUserSystem from "./vi/i18nUserSystem";
import i18nSubAccount from "./vi/i18nSubAccount";
import i18nTransPaymentDashboard from "./vi/i18nTransPaymentDashboard";
import i18nSignUpPaymentGateways from "./vi/i18nSignUpPaymentGateways";
import i18nSalesAddMerchant from "./vi/i18nSalesAddMerchant";
import i18nPaymentLink from "./vi/i18nPaymentLink";
import i18nMemasSetting from "./vi/i18nMemasSetting";
import i18nEmailForControl from "./vi/i18nEmailForControl";
import i18nRequestConfig from "./vi/i18nRequestConfig";
import i18nRevenueManagement from "./vi/i18nRevenueManagement";
import i18nCollentionPeriod from "./vi/i18nCollentionPeriod";
import i18nCustomerContacts from "./vi/i18nCustomerContacts";
import i18nFormRegistration from "./vi/i18nFormRegistration";
import i18nMerchantTransactionControl from "./vi/i18nMerchantTransactionControl";
import i18nReportControl from "./vi/i18nReportControl";
import i18nMerchant from "./vi/i18nMerchant";
export default {
  vi: {
    i18nBaseForm,
    i18nMain,
    i18nValidate,
    i18nCommon,
    i18nComponent,
    i18nEnum,
    i18nAsset,
    i18nAssetType,
    i18nLayoutColumn,
    i18nOrganizationUnit,
    i18nProvider,
    i18nLocation,
    i18nPickList,
    i18nJobPosition,
    i18nJobTitle,
    i18nJobPositionAsset,
    i18nRole,
    i18nEmployee,
    i18nReport,
    i18nUser,
    i18nCustomer,
    i18nDBOption,
    i18nAuditingLog,
    i18nAudit,
    i18nLogin,
    i18nTally,
    i18nAssetCategory,
    i18nAllocationReduce,
    i18nGetting,
    i18nMaintainRepair,
    i18nMultiReduce,
    i18nMultiAllocation,
    i18nIdentify,
    i18nImport,
    i18nColumn,
    i18nMaintenance,
    i18nSchedule,
    i18nAssetReduce,
    i18nLostCancelLiquidated,
    i18nTransfer,
    i18nTemplate,
    i18nTourGuide,
    i18nSY,
    i18nTransferAdd,
    i18nAssetRepairMaintenance,
    i18nDisposal,
    i18nAssetLostCancelLiquidated,
    i18nDashboard,
    i18nMultiDisposal,
    i18nPages,
    i18nPrintBarCode,
    i18nOption,
    i18nTransactionControl,
    i18nTransaction,
    i18nRefund,
    i18nUserSystem,
    i18nSubAccount,
    i18nTransPaymentDashboard,
    i18nSignUpPaymentGateways,
    i18nSalesAddMerchant,
    i18nPaymentLink,
    i18nMemasSetting,
    i18nEmailForControl,
    i18nRequestConfig,
    i18nRevenueManagement,
    i18nCollentionPeriod,
    i18nCustomerContacts,
    i18nFormRegistration,
    i18nMerchantTransactionControl,
    i18nReportControl,
    i18nMerchant,
  },
};
